import Stack from '@mui/material/Stack';
import { secondaryFontList } from '@theme';
import type React from 'react';

interface Props {
  title?: string | React.ReactElement<any>;
  titleIcon?: React.ReactNode;
}

export default ({ title, titleIcon }: Props) => (
  <Stack
    direction="row"
    sx={{
      gap: 1,
      alignContent: 'center',
      fontFamily: secondaryFontList,
    }}
  >
    {titleIcon && <span data-testid="dialog-title-icon">{titleIcon}</span>}
    <span data-testid="dialog-title-content">{title}</span>
  </Stack>
);
